import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

const ResetPassword = () => {
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const [infoMessage, setInfoMessage] = useState('');

  const email = localStorage.getItem('forgotEmail');
        useEffect(() => {
           if (email) {
             setInfoMessage(`Check your email ${email} to get the OTP`);
           }
         }, [email]);

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/forgot-password/complete/', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          otp,
          phone_number: '',
          country_code: '',
          password,
        }),
      });

      const result = await response.json();
      if (response.ok) {
        setError('');
        setSuccess('Password reset successful!');
        // navigate('/'); // Redirect to sign in page
        setTimeout(() => {
          navigate('/');
        }, 2000); 
      } else {
        setError(result.message || 'OTP invalid or expired.');
      }
    } catch (err) {
      setError('Something went wrong. Try again later.');
    }
  };

  return (
    <div className="signMainInOuter">
      <div className="signInOuter">
        <div className="logo"><img src="/assets/Flowlogic-Logo.svg" alt="FlowLogic Icon" /></div>
        <h4>Reset Password</h4>
                {/* Info Message */}
                {infoMessage && (
          <p style={{ color: 'darkgreen', fontWeight: 'bold', marginBottom: '5px' ,fontSize:'12px'}}>
            {infoMessage}
          </p>
        )}
        <form onSubmit={handleReset}>
          <div className="form-group">
            <input
              type="text"
              placeholder="Enter OTP"
              className="form-control"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="New Password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Confirm New Password"
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <Button variant="success" type="submit">Reset Password</Button>
        </form>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}
      </div>
    </div>
  );
};

export default ResetPassword;
